import { RecoverableBinding, recoverableField } from "../../../ServiceDesk/recovery/recoverable-control";

export class TextAreaBinding extends RecoverableBinding {
  /** true/false. If true, prevents the table from expanding horizontally. Defaults to false.*/
  public flex = "<?";

  /** Label text written above the control.*/
  public label = "@?";

  /** Placeholder text for the textarea. When not provided, the placeholder will be empty. This is a one time binding only. */
  public placeholder = "@?";

  /** The bound value of what is written in the control.*/
  public model = "=";

  /** name attribute given to the underlying textarea.*/
  public name = "@?";

  /** DEPRECATED. Use is-required. true/false. Sets the required attribute.*/
  public required = "@?";

  /**  true/false. Sets the required attribute.*/
  public isRequired = "@?";

  /** true/false. Whether the textarea can be resized by the user. Defaults to false.*/
  public resize = "<?";

  /** The height in text rows of the control by default.*/
  public rows = "<?";

  /**
   * true/false. Whether the textarea has a vertical scrollbar visible.
   * A scrollbar will be created regardless if text overflows. Defaults to false.
   * */
  public scroll = "<?";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  /** The maximum number of input characters the control will allow. This is a one time binding only.*/
  public maxLength = "@?";

  /** Called when the model text changes, takes a text: string as a parameter */
  public onModelChange = "&";

  /** Sets the invalid message content */
  public invalidMessage = "@?";

  /**  true/false. Whether the textarea can be readonly. Defaults to false. */
  public readonly = "<?";

  /** Added for accessibility */
  public ariaLabelledby = "@?";
}

/** Controller for Textarea component. */
export class TextareaController {
  public flex: boolean;
  public resize: boolean;
  public scroll: boolean;
  public classNames: Array<string> = [];
  public biId: string;
  public name: string;
  public isRequired: boolean;
  public required: boolean;
  public placeholder: string;
  @recoverableField
  public model: string;
  public onModelChange: (payload: { text: string }) => void;

  constructor() {
    if (!this.isRequired && this.required) {
      this.isRequired = this.required;
    }
  }

  /** Life cycle methods */
  public $onInit() {
    this.refreshView();
  }

  public $onChanges(changesObj: any) {
    this.refreshView();
  }

  public onChange() {
    this.onModelChange({ text: this.model });
  }

  private refreshView() {
    if (this.flex === true) {
      this.classNames.push("f-flex");
    }

    if (this.resize === true) {
      this.classNames.push("f-resize");
    } else {
      this.classNames.push("f-no-resize");
    }

    if (this.scroll === true) {
      this.classNames.push("f-scroll");
    }
  }
}
export const sdTextarea: ng.IComponentOptions = {
  bindings: <any>new TextAreaBinding(),
  controller: TextareaController,
  templateUrl: "../shellcommon/controls/textarea/textarea.html"
};
